import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { removeAPIPrefix } from "../../utils/url";

let materialProductionServiceInstance = null
const materialProductionReverb = () => materialProductionServiceInstance
const subdomain = window.location.host.split('.')[0]
const addressAPIWithoutPrefix = removeAPIPrefix(process?.env?.VUE_APP_MATERIAL_PRODUCTION_URL)
const baseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + process?.env?.VUE_APP_MATERIAL_PRODUCTION_URL
const reverbBaseURL = process?.env?.VUE_APP_APPLICATION_SECURITY + subdomain + '.' + addressAPIWithoutPrefix
const reverbSecretKey = process?.env?.VUE_APP_MATERIALS_PRODUCTION_API_REVERB_KEY
const shouldInitializeReverb = Boolean(!materialProductionServiceInstance && addressAPIWithoutPrefix && subdomain && reverbSecretKey)

const initializeMaterialProductionReverb = (userToken) => {
    if (shouldInitializeReverb && userToken) {
        const reverbWsConnection = () => {
            if (process?.env?.VUE_APP !== 'localhost') {
              return `${subdomain}.${addressAPIWithoutPrefix}`
          }  
          return 'localhost'   
        }

        try {
            materialProductionServiceInstance = new Echo({
                broadcaster: 'reverb',
                  key: reverbSecretKey,
                  wsHost: reverbWsConnection(),
                  wsPort: process?.env?.VUE_APP === 'localhost' ? 6005: 80,
                  wssPort: process?.env?.VUE_APP === 'localhost' ? 6005 : 443,
                  forceTLS: window.location.protocol === 'https',
                  path: '/app',
                  enabledTransports: ['ws', 'wss'],
                  authEndpoint: `${reverbBaseURL}/broadcasting/auth`,
                  auth: {
                      headers: {
                          Authorization: 'Bearer ' + userToken,
                      },
                  }
              })
        } catch (error) {
            console.error(error)
        }
    }
}

const leaveMaterialProductionReverbPrivateChannel = (channelName) => {
    if (materialProductionServiceInstance && channelName) {
        materialProductionServiceInstance.leave(`private-${channelName}`)
    }
}

const verifyMaterialProductionServiceReverb = (consumerId) => {
    if (materialProductionServiceInstance) {
        let connected = false
        try {
            materialProductionReverb().private(`App.Models.User.${consumerId}`)
            connected = true
        } catch (error) {
            console.error("Material Production WS: ", error)
        } finally {
            if (connected) {
                setTimeout(() => {
                    materialProductionReverb().leave(`App.Models.User.${consumerId}`)
                }, 10000)
            }
        }
    }
}

export {
    verifyMaterialProductionServiceReverb,
    leaveMaterialProductionReverbPrivateChannel,
    initializeMaterialProductionReverb,
    materialProductionReverb
}